import React from 'react';
import Cover from '../../components/Cover/Cover';
import Focus from '../../components/Focus/Focus';
import Ingredients from '../../components/Ingredients/Ingredients';
import Facts from '../../components/Facts/Facts';
import Delivery from '../../components/Delivery/Delivery';
import DeliveryMap from '../../components/DeliveryMap/DeliveryMap';
import LegalInfo from '../../components/LegalInfo/LegalInfo';
import SubscribePromoWaypoint from '../../components/SubscribePromo/SubscribePromoWaypoint';
import SubscribePromo from '../../components/SubscribePromo/SubscribePromo';
import OrderModal from '../../components/OrderModal/OrderModal';

const Landing = () => {
  return (
    <section>
      <Cover />
      <Focus />
      <Ingredients />
      <Facts />
      <Delivery />
      <SubscribePromoWaypoint />
      <DeliveryMap />
      <LegalInfo />

      <OrderModal />
      <SubscribePromo />
    </section>
  );
};

export default Landing;



// WEBPACK FOOTER //
// ./src/containers/Landing/Landing.js